import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import QueryProvider from '@providers/QueryProvider';
import theme from '@styles/theme';
import { ThemeProvider } from 'styled-components';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <ThemeProvider theme={theme}>
        <QueryProvider>
            <App />
        </QueryProvider>
    </ThemeProvider>
);
